const unitOptimizerHu = {
	unitOptimizerTable: 'Unit Optimizer',
	unitOptimizerEditForm: 'Unit Optimizer',
	name: 'Name',
	type: 'Type',
	value: 'Value',
	unitName: 'Unit Name',
	piMeasurementReaderTasks: 'PI Measurement Reader Tasks',
	labMeasurementReaderTasks: 'Lab Measurement Reader Tasks',
	measurementMergeTask: 'Measurement Merge Task',
	dataCleanTask: 'Data Clean Task',
	modelValidationTask: 'Model Validation Task',
	optimizeUnitTask: 'Optimize Unit Task',
	outlierDetectionTask: 'Outlier Detection Task',
	measurement: 'Measurement',
	optimizationCase: 'Optimization Case',
	unitOptimizerLog: 'Unit Optimizer Log',
	whatIf: 'What If',
	uom: 'UOM',
	cumulativeUom: 'Cumulative UOM',
	multiplier: 'Multiplier',
	userGroup: 'User Group'
};

export default unitOptimizerHu;